export default (positionString: string) => `Stap ${positionString}`;
